import { render, staticRenderFns } from "./ManageNoticeDetail.vue?vue&type=template&id=190a2b2c&scoped=true&lang=pug&"
import script from "./ManageNoticeDetail.vue?vue&type=script&lang=ts&"
export * from "./ManageNoticeDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ManageNoticeDetail.vue?vue&type=style&index=0&id=190a2b2c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a2b2c",
  null
  
)

export default component.exports